import React from "react";

// Parameter cell of the raw data lists (dashboard and admin report): the parameter name followed, on the same line, by its context in
// small light grey text with an icon instead of words (it wraps to the next line only when the column is too narrow):
//   sitemap icon     = the test-level parent parameter
//   right-arrow icon = the sub child parameter feeds the sub-parameter(s) that follow
// ParentParameterName is "" for an individual parameter, the test-level parent for a sub-parameter,
// and "Sub 1, Sub 2 / Parent" for a sub child parameter (the sub-parameters it feeds / the parent).
const contextStyle = { fontSize: "0.72rem", color: "#9aa0a6" };

const parameterText = (row) => {
  const context = row.ParentParameterName;
  if (!context) return row.ParameterName;
  const slash = context.lastIndexOf(" / ");
  const subNames = slash >= 0 ? context.slice(0, slash) : "";
  const parentName = slash >= 0 ? context.slice(slash + 3) : context;
  return (
    <>
      {row.ParameterName}
      <span style={contextStyle}>
        {" "}
        {subNames && (
          <>
            <i className="fa-solid fa-right-long me-1" title="Feeds the sub-parameter" aria-label="Feeds the sub-parameter"></i>
            {subNames}
            <span className="mx-1">|</span>
          </>
        )}
        <i className="fa-solid fa-sitemap me-1" title="Parent parameter" aria-label="Parent parameter"></i>
        {parentName}
      </span>
    </>
  );
};

export default parameterText;
